<template>
	<div v-if="good_detail">
		<van-popup v-model="book_time_pop" catchtouchmove="ture" position="bottom" style="border-radius: 8px">
			<div class="book_time">
				<div class="book_time_title font_weight">请选择时间</div>
				<div class="book_time_date">
					<div v-for="(item_date,index_date) in good_detail.stocks.date_list" :key="'date'+index_date"
						:class="[{'book_time_date_itemS':stock_date_index==index_date},'book_time_date_item']" 
						@click="selectDate(index_date)">
						<div>
							<div class="book_time_date_item_1">{{item_date.week}}</div>
							<div class="book_time_date_item_2 font_weight">{{item_date.date_ndateD}}</div>
						</div>
					</div>
				</div>
				<div class="book_time_times">
					<van-row>
						<van-col span="6" v-for="(item_time,index_time) in good_detail.stocks.times" :key="'time'+index_time">
							<div class="book_time_times_block">
								<div :class="[{'book_time_times_itemS':index_time==time_index},'book_time_times_item']" @click="selecttime(index_time)">
									{{item_time}}
								</div>
							</div>
						</van-col>
					</van-row>
				</div>
				<div class="book_time_btn">
					<div @click="toCreateOrder()" :class="[{'book_time_buttomN':time_index<0},'book_time_buttom']">
						确认预约
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>

	export default {
		props:['good_detail'],
		data() {
			return {
				book_time_pop: false,
				stock_date_index:0,
				time_index:-1,
			}
		},
		mounted() {},
		methods: {
			selectDate(e){
				this.stock_date_index=e
				this.time_index=-1
			},
			selecttime(e){
				this.time_index=e
			},
			// 切换pop
			openTimePop() {
				this.book_time_pop = true
			},
			closeTimePop() {
				this.book_time_pop = false
			},
			// 立即下单
			toCreateOrder() {
				if(this.time_index>=0){
					var params={
						date:this.good_detail.stocks.dates[this.stock_date_index].date,
						time:this.good_detail.stocks.times[this.time_index]
					}
					this.$emit('updataBookTime',params)
					return
					var date=this.good_detail.stocks.dates[this.stock_date_index].date
					var time=this.good_detail.stocks.times[this.time_index]
					var goods_id=this.good_detail.goods_id
					this.$router.push({
						name:'create_order',
						params:{
							goods_id:goods_id,
							date:date,
							time:time
						}
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.book_time {
		width: 100%;
		padding: 30*@vm_base;
	}

	.book_time_title {
		width: 100%;
		font-size: 30*@vm_base;
		color: #333333;
	}

	.book_time_date {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 26*@vm_base;
		margin-bottom: 16*@vm_base;

		.book_time_date_item {
			width: 80*@vm_base;
			height: 92*@vm_base;
			border-radius: 16*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			color: #666666;

			.book_time_date_item_1 {
				font-size: 20*@vm_base;
			}

			.book_time_date_item_2 {
				font-size: 30*@vm_base;
				margin-top: 6*@vm_base;
			}
		}

		.book_time_date_itemS {
			background: linear-gradient(145deg, #FFA662 0%, #FA7D23 100%);
			color: #FFFFFF;
		}
	}

	.book_time_times {
		width: 100%;
		min-height: 310*@vm_base;

		.book_time_times_block {
			width: 100%;
			margin-bottom: 10*@vm_base;
			padding: 0 5*@vm_base;

			.book_time_times_item {
				width: 100%;
				height: 64*@vm_base;
				border-radius: 10*@vm_base;
				border: 1*@vm_base solid #D9D9D9;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 26*@vm_base;
				color: #333333;
			}

			.book_time_times_itemS {
				border: 1*@vm_base solid transparent;
				background: linear-gradient(145deg, #FFA662 0%, #FA7D23 100%);
				color: #FFFFFF;
			}
		}
	}

	.book_time_btn {
		width: 100%;
		padding: 28*@vm_base 45*@vm_base 0 45*@vm_base;

		.book_time_buttom {
			width: 100%;
			height: 80*@vm_base;
			background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 32*@vm_base;
			color: #FFFFFF;
		}

		.book_time_buttomN {
			background: #D9D9D9;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/book_time.vue